import { enum_ } from "valibot"

/**
 * Represents the ID of a built-in input profile preset
 */
export enum InputProfilePresetId {
  /**
   * Inspired by the 2004 Dawn of War game, Civ4, Civ5
   */
  ClassicKeyboard = 1,
  
  /**
   * Grid-based key layout
   */
  GridKeysKeyboard = 2,
  
  /**
   * Modern RTS game controls
   */
  ModernKeyboard = 3,
  
  /**
   * Default gamepad controls
   */
  DefaultGamepad = 101,
}

export const InputProfilePresetIdSchema = enum_(InputProfilePresetId, 'Invalid Input Profile Preset ID')
